import urls from 'src/constants/urls';

export const isLanding = location => {
  const { pathname } = location;
  return urls.landing() === pathname;
};
